function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import HeaderDesktopWrapper from './HeaderDesktopWrapper';
import HeaderMobileWrapper from './HeaderMobileWrapper';
import useIsMobile from '../Utils/customHooks/useIsMobile';
import '@dtsl/css-header/dist/index.css';
export function IsMobile() {
  const {
    isMobile
  } = useIsMobile();
  return isMobile;
}
function Header(props) {
  const isMobile = IsMobile();
  return isMobile ? /*#__PURE__*/React.createElement(HeaderMobileWrapper, _extends({}, props, {
    isMobile: isMobile
  })) : /*#__PURE__*/React.createElement(HeaderDesktopWrapper, props);
}
export default Header;